import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, withSystem, withMeta, Atom} from '@packages/systems/wfdl';
import type {AtomRenderProps} from '@packages/systems/wfdl';
import {TText, TRecord} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  maybeAddEventIdsFromData,
  maybeAddEventTrackingAttribute,
} from '@packages/systems/optimization/utils';
import {
  useRuntimeEnvironment,
  useOptimizationClickMode,
} from '@packages/systems/render';
import {EVENT_IDS_ATOM_FIELD} from '@packages/systems/optimization/constants';

const FormButton = Atom.createRender(
  ({attributes, classes, generateAttributes, data}: AtomRenderProps) => {
    const formButtonClasses = classes.push('w-button');
    const runtimeEnvironment = useRuntimeEnvironment();
    const optimizationClickMode = useOptimizationClickMode();
    const formButtonAttributes = attributes.withMutations((_attributes) => {
      _attributes.update(maybeAddEventIdsFromData(runtimeEnvironment, data));
      _attributes.update(
        maybeAddEventTrackingAttribute(
          runtimeEnvironment,
          optimizationClickMode
        )
      );
    });
    return (
      <input {...generateAttributes(formButtonAttributes, formButtonClasses)} />
    );
  }
);

const config = createDevlinkAtom({
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  constraints: {
    ancestors: [
      {
        is: 'FormForm',
        rule: 'ExactlyOne',
      },
    ],
  },
  showEmpty: false,
  displayName: 'Submit Button',
  render: FormButton,
  fields: {
    form: withSystem(
      {private: true},
      TRecord({
        type: withSystem({defaultValue: 'button'}, TText),
      })
    ),
    eventIds: EVENT_IDS_ATOM_FIELD,
    attr: withSystem(
      {private: false},
      TRecord({
        type: withSystem({private: true, defaultValue: 'submit'}, TText),
        value: withMeta(
          {placeholder: 'e.g. Submit'},
          withSystem(
            {
              defaultValue: 'Submit',
              label: 'Text',
              isBindable: true,
              isLocalizable: true,
            },
            TText
          )
        ),
        'data-wait': withMeta(
          {placeholder: 'e.g. Please wait...'},
          withSystem(
            {
              defaultValue: 'Please wait...',
              label: 'Loading',
              isBindable: true,
              isLocalizable: true,
            },
            TText
          )
        ),
      })
    ),
  },
  // Add the native ID path in attributes for Analyze tracking
  autoEngagementTrackingAttribute: true,
});

export default config;
